var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { useCallback, useContext, useEffect, useState } from "react";
import { isProduction } from "../utils/env";
import { defaultAssetsYieldData, ExternalAPIDataContext, } from "./externalAPIDataContext";
export var useFetchAssetsYield = function () {
    var _a = useState(defaultAssetsYieldData), data = _a[0], setData = _a[1];
    var _b = useState(true), loading = _b[0], setLoading = _b[1];
    var fetchAssetsYield = useCallback(function () { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            if (!isProduction()) {
                console.time("Asset Yield Data Fetch"); // eslint-disable-line
            }
            try {
                throw new Error('Error while executing the code');
                // const response = await axios.get<DefiScoreOpportunitiesResponse>(
                //   `https://api.defiscore.io/earn/opportunities`
                // );
                // const yieldInfoObj = Object.fromEntries(
                //   DefiScoreTokenList.map((token) => [token, new Array(0)])
                // ) as AssetsYieldInfoData;
                // for (let i = 0; i < response.data.data.length; i++) {
                //   const curr = response.data.data[i];
                //   yieldInfoObj[curr.token].push({
                //     protocol: curr.protocol,
                //     apr: parseFloat(curr.aprHistory[curr.aprHistory.length - 1].value),
                //   });
                // }
                // setData(
                //   Object.fromEntries(
                //     Object.keys(yieldInfoObj).map((token) => [
                //       token,
                //       yieldInfoObj[token as DefiScoreToken].sort((a, b) =>
                //         a.apr < b.apr ? 1 : -1
                //       ),
                //     ])
                //   ) as AssetsYieldInfoData
                // );
                // if (!isProduction()) {
                //   console.timeEnd("Asset Yield Data Fetch"); // eslint-disable-line
                // }
            }
            catch (error) {
                if (!isProduction()) {
                    console.timeEnd("Asset Yield Data Fetch FAILED"); // eslint-disable-line
                }
            }
            finally {
                setLoading(false);
            }
            return [2 /*return*/];
        });
    }); }, []);
    useEffect(function () {
        fetchAssetsYield();
    }, [fetchAssetsYield]);
    return { data: data, loading: loading };
};
var useAssetsYield = function (asset) {
    var contextData = useContext(ExternalAPIDataContext);
    var baseAsset = asset === "WETH" ? "eth" : asset.toLowerCase();
    // switch (asset) {
    //   case "yvUSDC":
    //     baseAsset = "usdc";
    //     break;
    //   case "stETH":
    //     baseAsset = "eth";
    // }
    return contextData.assetsYield.data[baseAsset];
};
export default useAssetsYield;
//# sourceMappingURL=useAssetsYield.js.map